import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const LazyStudentHandoff = React.lazy(
	() => import(/* webpackChunkName: 'StudentHandoff' */ './StudentHandoff')
);

export default () => {
	return {
		path: 'student/handoff',
		element: <AsyncLoading component={<LazyStudentHandoff />} />,
	};
};
